const ModalWhats = function () {

    const modal = function () {
        var modalSearch = $("#modal-form");
        modalSearch.fadeToggle(200);
    }

    const closeModal = function (el) {
        if (el.attr('data-modal') == "modal") {
            el.closest('.elm-modal').fadeOut(100);
        } else {
            modal();
        }
    }

    return {
        init: function () {

            $(document).on("click", ".modal-form", function (e) {
                e.preventDefault();
                modal()
            });

            $(document).on("click", ".s-close-form", function (e) {
                e.preventDefault();
                closeModal($(this));
            });
        }
    }

}();

module.exports = ModalWhats;